<div class="main-container" *ngIf="!isLoading" data-cy="ar-payment-plan-view">

  <div class="sub-container" data-cy="ar-payment-plan-view-sub-container">

    <div id="main-plan-container" data-cy="ar-payment-plan-view-main-container">

      <div class="invoice-header-container" data-cy="ar-payment-plan-view-header-container">
        <div class="invoice-header" data-cy="ar-payment-plan-view-header">
          Payment Plan
        </div>

      </div>

      <mat-divider data-cy="ar-payment-plan-view-divider-1"></mat-divider>

      <div class="invoice-sub-header" data-cy="ar-payment-plan-view-sub-header">

        <div class="date-field" data-cy="ar-payment-plan-view-description-field">
          <div class="date-header" data-cy="ar-payment-plan-view-description-header">Description: </div>
          <div class="date-data" data-cy="ar-payment-plan-view-description-data">
            {{ paymentPlan.Description }}
          </div>
        </div>

        <div class="status-field" data-cy="ar-payment-plan-view-status-field">
          <div class="date-header" data-cy="ar-payment-plan-view-status-header">Status: </div>
          <div class="date-data" data-cy="ar-payment-plan-view-status-data">
            {{ hasUnpaidItems ? (paymentPlan.isPatientAccepted ? 'Accepted' : 'Awaiting Approval') : 'Paid' }}
          </div>
        </div>

      </div>

      <mat-divider data-cy="ar-payment-plan-view-divider-2"></mat-divider>

      <div class="services-container" data-cy="ar-payment-plan-view-services-container">

        <div class="service-column"
             [class.hide-column]="!columnHeader.show"
             *ngFor="let columnHeader of dataInvoiceItem.columns"
             data-cy="ar-payment-plan-view-service-column">

          <div class="column-header" data-cy="ar-payment-plan-view-column-header">
            {{ columnHeader.title }}
          </div>

          <div class="column-item-display-value" [class.hide-column]="!item.showItem" *ngFor="let item of dataInvoiceItem.billableItems" data-cy="ar-payment-plan-view-column-item">

            <div *ngIf="columnHeader.pipe === 'date'" data-cy="ar-payment-plan-view-date-item">
              {{ item[columnHeader.key] | date }}
            </div>
            <div *ngIf="columnHeader.pipe === 'currency'" data-cy="ar-payment-plan-view-currency-item">
              {{ item[columnHeader.key] | currency }}
            </div>
            <div *ngIf="columnHeader.pipe === 'trim'" data-cy="ar-payment-plan-view-trim-item">
              {{ item[columnHeader.key] }}
            </div>
            <div *ngIf="columnHeader.pipe === 'none'" data-cy="ar-payment-plan-view-none-item">
              {{ item[columnHeader.key] }}
            </div>

          </div>

        </div>

      </div>

      <mat-divider data-cy="ar-payment-plan-view-divider-3"></mat-divider>

      <div class="invoice-sub-header" data-cy="ar-payment-plan-view-payments-header">

        <div class="date-field" data-cy="ar-payment-plan-view-payments-field">
          <div class="date-header" data-cy="ar-payment-plan-view-payments-label">Payments </div>
          <div class="date-data" data-cy="ar-payment-plan-view-payments-count">
            {{ dataInvoiceItem.paymentItems.length }}
          </div>
        </div>

      </div>

      <mat-divider data-cy="ar-payment-plan-view-divider-4"></mat-divider>

      <div class="services-container" data-cy="ar-payment-plan-view-payments-container">
        <!-- show the # of payments and cost -->
        <div class="service-column"
             [class.hide-column]="!columnHeader.show"
             *ngFor="let columnHeader of dataInvoiceItem.paymentColumns"
             data-cy="ar-payment-plan-view-payment-column">

          <div class="column-header" data-cy="ar-payment-plan-view-payment-header">
            {{ columnHeader.title }}
          </div>

          <div class="column-item-display-value" [class.hide-column]="!item.showItem" *ngFor="let item of dataInvoiceItem.paymentItems" data-cy="ar-payment-plan-view-payment-item">

            <div *ngIf="columnHeader.pipe === 'date'" data-cy="ar-payment-plan-view-payment-date">
              {{ item[columnHeader.key] | date }}
            </div>
            <div *ngIf="columnHeader.pipe === 'currency'" data-cy="ar-payment-plan-view-payment-currency">
              {{ item[columnHeader.key] | currency }}
            </div>
            <div *ngIf="columnHeader.pipe === 'trim'" data-cy="ar-payment-plan-view-payment-trim">
              {{ item[columnHeader.key] }}
            </div>
            <div *ngIf="columnHeader.pipe === 'none'" data-cy="ar-payment-plan-view-payment-none">
              {{ item[columnHeader.key] }}
            </div>

          </div>

        </div>
      </div>

      <mat-divider data-cy="ar-payment-plan-view-divider-5"></mat-divider>

      <div class="total-container" data-cy="ar-payment-plan-view-total-container">
        <div class="total-header" data-cy="ar-payment-plan-view-total-header">
          Total due:
        </div>
        <div class="total-data" data-cy="ar-payment-plan-view-total-data">
          {{ dataInvoiceItem.totalDue | currency }}
        </div>
      </div>

    </div>
  </div>

  <div class="form-container" data-cy="ar-payment-plan-view-form-container">

    <div class="action-container" data-cy="ar-payment-plan-view-action-container">
      <button mat-raised-button class="action-button" color="primary" (click)="generatePDF()" data-cy="ar-payment-plan-view-pdf-btn"><i class="material-icons">picture_as_pdf</i></button>
      <button mat-raised-button class="action-button" color="primary" *ngIf="hasUnpaidItems && paymentPlan.isPatientAccepted" (click)="makePayment()" data-cy="ar-payment-plan-view-payment-btn">Make a payment</button>
      <button mat-raised-button *ngIf="!paymentPlan.isPatientAccepted" class="action-button" color="primary" (click)="approvePlan()" [disabled]="paymentPlan.isPatientAccepted" data-cy="ar-payment-plan-view-approve-btn">Approve plan</button>
      <button mat-raised-button class="action-button" color="primary" (click)="close()" data-cy="ar-payment-plan-view-done-btn">Done</button>
    </div>

    <div class="message" *ngIf="!paymentPlan.isPatientAccepted" data-cy="ar-payment-plan-view-approve-message">
      Please approve the plan before making a payment
    </div>

    <div class="message" *ngIf="paymentPlan.isPatientAccepted && !hasUnpaidItems" data-cy="ar-payment-plan-view-paid-message">
      This plan has been paid off. No further payment required.
    </div>

    <div class="payment-form" *ngIf="paymentPlan.isPatientAccepted && hasUnpaidItems" data-cy="ar-payment-plan-view-payment-form">

      <div class="message" *ngIf="!paymentIsDue" data-cy="ar-payment-plan-view-early-payment-message">
        No payment is required at this time but you can still make an early payment.
      </div>

      <div class="message" *ngIf="paymentIsDue" data-cy="ar-payment-plan-view-due-payment-message">
        Payment is now due. Please make a payment.
      </div>

    </div>

  </div>
  
</div>

<div class="spinner-container" *ngIf="isLoading" data-cy="ar-payment-plan-view-spinner-container">
  <mat-spinner data-cy="ar-payment-plan-view-spinner"></mat-spinner>
</div>
